import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]: {
		url: '/company/:companyId/business_processes/active_plan_works/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_POPUP]: {
		url: '/company/:companyId/business_processes/active_plan_works/:activePlanWorkId/popup/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_PREVIEW]: {
		url: '/company/:companyId/business_processes/active_plan_works/:activePlanWorkId/preview/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORK]: {
		url: '/company/:companyId/business_processes/active_plan_works/:activePlanWorkId',
	},
}
